import resolveDefaultOpt from "@/utils/resolveDefaultOpt"

export const resolveWorkCover = workItem => {
  workItem.mediaFiles = workItem.mediaFiles || []
  workItem.videos = workItem.videos || []
  workItem.reviews = workItem.reviews || []
  const worksDefaultPic = workItem.worksDefaultPic
  const mediaFilesCoverItem = workItem.mediaFiles.find(item => item.cover)
  const mediaFilesCover = mediaFilesCoverItem ? mediaFilesCoverItem.url : ""
  const videoCover = workItem.videos[0] ? workItem.videos[0].coverImgUrl : ""
  const mediaDefaultCover = workItem.mediaFiles[0] ? workItem.mediaFiles[0].watermarkUrl || workItem.mediaFiles[0].url : ""
  const cover = mediaFilesCover || videoCover || mediaDefaultCover || worksDefaultPic
  return cover
}

export const resolveWorkList = workList => {
  workList.forEach(item => {
    Object.assign(item, item.defaultOpt, resolveDefaultOpt(item.defaultOpt))
    item.cover = resolveWorkCover(item)
    item.mediaFiles = item.mediaFiles || []
    item.mediaFiles.forEach(childItem => {
      childItem.url = childItem.url || childItem.watermarkUrl
    })
    switch (item.reviewStatus) {
      case "WAIT":
        item.reviewStatusTxt = "待审核"
        break
      case "PASS":
        item.reviewStatusTxt = "审核通过"
        break
      case "REJECT":
        item.reviewStatusTxt = "审核未通过"
        break
      case "REVOKE":
        item.reviewStatusTxt = "审核未通过"
        break
    }
  })
}
